<template>
  <div v-show="!$store.state.newConfig.general.useSidebarSubnavigation && !$store.state.hideNav && (navItems.length || activeNavItems.length)" class="sub-bottom-bar" :class="[{ 'sub-bottom-bar--stack': navItems.length > 8 }, { 'sub-bottom-bar--video-active': isReferenceVideoActive }]">
    <transition name="fade">
      <div class="sub-bottom-bar__wrapper" v-show="navItems.length || activeNavItems.length">
        <transition-group class="sub-bottom-bar__nav-items" :class="[{ 'padding-level--0': navItems.length >= 15 }, { 'padding-level--1': navItems.length < 15 && navItems.length >= 13 }, { 'padding-level--2': navItems.length < 13 && navItems.length >= 11 }]" @before-enter="beforeEnter" @enter="enter" @afterEnter="afterEnter" @leave="leave">
          <div v-for="(navItem, index) in activeNavItems" class="sub-bottom-bar__nav-item-wrapper" :data-index="index" :key="navItem._id" :data-id="navItem._id">
            <router-link
              v-if="!isItemExternal(navItem)"
              class="sub-bottom-bar__nav-button touch"
              :class="{ 'router-link-active': isNavItemActive(navItem) }"
              tag="button"
              :to="getItemUrl(navItem)"
              @click.native="
                triggerMedia(navItem.label['en']);
                playClickSound();
                bus.$emit('navClick');
              "
              :dir="lang.dir"
            >
              <div v-if="navItem.icon && navItem.icon[1]" class="icon">
                <fa :icon="navItem.icon" />
              </div>
              <div v-html="navItem.label[lang.code] || navItem.label['en']"></div>
            </router-link>
            <button v-if="isItemExternal(navItem)" class="sub-bottom-bar__nav-button touch" tag="button" @click="handleExternalLinkClick(navItem)" :dir="lang.dir">
              <div v-if="navItem.icon && navItem.icon[1]" class="icon">
                <fa :icon="navItem.icon" />
              </div>
              <div v-html="navItem.label[lang.code] || navItem.label['en']"></div>
            </button>
          </div>
        </transition-group>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "../main";
import _ from "lodash";
import { isRouteActiveForPath } from "@/utils/livingRoute";

export default {
  props: ["nav-items"],

  data() {
    return {
      activeNavItems: [],
      bus: bus,
      isReferenceVideoActive: false,
    };
  },

  computed: {
    ...mapGetters({
      activePage: "activePage",
      lang: "language",
    }),
  },

  watch: {
    navItems: {
      handler(newNavItems, oldNavItems) {
        if (!_.isEqual(oldNavItems, newNavItems)) {
          this.activeNavItems = [];
          if (newNavItems.length) {
            this.$store.commit("addAnimationToQueue", "SubBottomBar");
          }
        }
      },
      immediate: true,
    },
  },

  mounted() {
    bus.$on("animateSubBottomBar", () => {
      if (!_.isEqual(this.activeNavItems, this.navItems)) {
        setTimeout(() => {
          this.activeNavItems = this.navItems;
        }, 300);
      } else {
        bus.$emit("finishedAnimation", "SubBottomBar");
      }
    });

    bus.$on("referenceVideoActiveChanged", (val) => {
      this.isReferenceVideoActive = val;
    });
  },

  beforeDestroy() {
    bus.$off("referenceVideoActiveChanged");
  },

  methods: {
    ...mapActions(["playClickSound"]),

    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(25%)";
    },

    enter(el, done) {
      setTimeout(() => {
        el.style.opacity = 1;
        el.style.transform = "translateY(0)";
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`;
        done();
      }, (parseInt(el.dataset.index) + 1) * 150);
    },

    afterEnter(el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        bus.$emit("finishedAnimation", "SubBottomBar");
      }
    },

    leave(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(25%)";
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0)`;
    },

    isItemExternal(navItem) {
      return navItem && navItem.externalUrl && navItem.externalUrl.length;
    },

    handleExternalLinkClick(navItem) {
      this.playClickSound();
      this.triggerMedia(navItem.label["en"]);
      if (this.$store.state.navMaster && this.$store.state.socket) {
        this.$store.state.socket.emit("navigatedExternalUrl", navItem.externalUrl);
        setTimeout(() => {
          window.location.href = navItem.externalUrl;
        }, 100);
      } else {
        window.location.href = navItem.externalUrl;
      }
    },

    getItemUrl(navItem) {
      if (navItem.customRoute) {
        return navItem.customRoute;
      }

      if (navItem.pageId) {
        return /category/ + this.$store.state.route.params.categoryId + "/page/" + navItem.pageId;
      }

      if (navItem.to) {
        return navItem.to;
      }

      return "";
    },

    isNavItemActive(item) {
      return isRouteActiveForPath(this.$route, this.getItemUrl(item));
    },

    triggerMedia(pageName) {
      const formattedPageName = pageName.toLowerCase().replaceAll(" ", "-");
      this.$store.dispatch("triggerVideo", `${process.env.VUE_APP_PROJECT}_${formattedPageName}.mp4`);
      this.$store.dispatch("announceSwarmContext", formattedPageName);
    },
  },
};
</script>
<style lang="scss" scoped>
.sub-bottom-bar {
  bottom: 10rem;
  left: 0;
  right: 32.5rem;
  height: 6rem;
  position: absolute;
  z-index: var(--subbottombar-z-index);

  .layout-switched & {
    bottom: initial;
    top: 10rem;
  }

  &--stack {
    height: 9.3rem;

    .sub-bottom-bar__nav-items {
      height: 7rem;
      margin-top: 0.8rem;
    }
  }

  &__wrapper {
    background-color: var(--subbottombar-bg-color);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  &__nav-item-wrapper {
    display: flex;
  }

  &__nav-items {
    align-items: space-around;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    justify-content: center;
  }

  &__nav-button {
    background: var(--button-background);
    border-radius: var(--border-radius);
    box-shadow: var(--button-box-shadow);
    color: var(--button-color);
    display: block;
    margin: auto 1rem;
    padding: 0.2rem 0.5rem 0;
    line-height: 1;
    height: 2.5rem;
    width: 17.5rem;
    font-size: 1.1rem;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      margin-right: 1em;
    }

    &.router-link-active {
      background: var(--button-background-active);
      color: var(--button-color-active);
    }
  }

  // if reference slider video active, darken background to match overlays
  &--video-active {
    background: rgba(0, 0, 0, 0.85);
  }
}
</style>
